import React, { useEffect, useRef } from "react";
import "./AscendDrawings.scss";

export const AscendNameDialog: React.FC<{
  defaultValue: string;
  onSubmit: (name: string) => void;
  onCancel: () => void;
}> = ({ defaultValue, onSubmit, onCancel }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.select();
  }, []);

  return (
    <div className="ascend-modal-backdrop" onClick={onCancel}>
      <form
        className="ascend-modal"
        onClick={(e) => e.stopPropagation()}
        onSubmit={(e) => {
          e.preventDefault();
          onSubmit(inputRef.current?.value.trim() || "Untitled");
        }}
      >
        <label htmlFor="ascend-name-input">Name this drawing</label>
        <input
          id="ascend-name-input"
          ref={inputRef}
          type="text"
          defaultValue={defaultValue}
        />
        <div className="ascend-modal__actions">
          <button type="button" onClick={onCancel}>
            Cancel
          </button>
          <button type="submit" className="primary">
            Save
          </button>
        </div>
      </form>
    </div>
  );
};
